if (navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i)) {
  document.querySelector('html').classList.add('is--ios');
}



// WEBPACK FOOTER //
// ./assets/js/components/ios.js